import { BaseSecuredApi } from "./BaseSecuredApi";

class DigitalDeposit extends BaseSecuredApi {

    constructor() {
        super("DigitalDeposit");
    }

    customerAvailableFund() {
        return this.GET({
            action: 'customerAvailableFund',
            cache: true
        });
    }
}

export const DigitalDepositApi = new DigitalDeposit(); 